<template>
	<div
	 id="loading"
	 v-if="loading"
	>
		<div class="fl spinner1">
			<div class="double-bounce1"></div>
			<div class="double-bounce2"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Loading",
	props: ["loading"]
};
</script>
